package com.tovtalk.ui.screen.onboarding

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Arrangement
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.layout.FlowRow
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import com.tovtalk.domain.entity.Category
import com.tovtalk.ui.theme.TovTalkBrand
import com.tovtalk.utils.strings.StringProvider

@OptIn(ExperimentalLayoutApi::class)
@Composable
fun CategoriesScreen(
    categories: List<Category>,
    selectedIds: Set<Int>,
    onToggle: (Int) -> Unit,
    onAdvance: () -> Unit,
    onBack: (() -> Unit)? = null,
) {
    OnboardingLayout(
        progressCurrent = 3,
        progressTotal = 4,
        onSkip = onAdvance,
        onBack = onBack,
        ctaText = StringProvider.get("onboarding_common_next"),
        onCta = onAdvance,
        ctaEnabled = selectedIds.isNotEmpty(),
        headerContent = {
            OnboardingHeader(
                eyebrow = StringProvider.get("onboarding_step_label_3_of_4"),
                title = StringProvider.get("onboarding_categories_title"),
                subtitle = StringProvider.get("onboarding_categories_subtitle"),
            )
        },
    ) {
        FlowRow(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 24.dp, vertical = 16.dp),
            horizontalArrangement = Arrangement.spacedBy(8.dp),
            verticalArrangement = Arrangement.spacedBy(8.dp),
        ) {
            categories.forEach { category ->
                CategoryPill(
                    name = category.name,
                    selected = category.id in selectedIds,
                    onClick = { onToggle(category.id) },
                )
            }
        }

        Spacer(Modifier.height(8.dp))
    }
}

@Composable
private fun CategoryPill(
    name: String,
    selected: Boolean,
    onClick: () -> Unit,
) {
    val shape = RoundedCornerShape(100.dp)
    val bg = if (selected) TovTalkBrand else Color.White.copy(alpha = 0.06f)
    val borderColor = if (selected) Color.Transparent else Color.White.copy(alpha = 0.10f)

    Box(
        modifier = Modifier
            .clip(shape)
            .background(bg)
            .then(
                if (selected) Modifier
                else Modifier.border(1.dp, borderColor, shape),
            )
            .clickable(onClick = onClick)
            .padding(horizontal = 14.dp, vertical = 9.dp),
    ) {
        Text(
            text = name,
            color = Color.White,
            fontSize = 13.sp,
            fontWeight = if (selected) FontWeight.SemiBold else FontWeight.Normal,
        )
    }
}
